import { Container, ContainerGutter, CTA } from '@volkswagen-onehub/components-core';
import React, { useEffect, useState } from 'react';
import { formService } from '../../../../form-service';
import { useFormField } from '../../../../hooks/use-form-field';
import { Option } from '../../../../types/form-types';

type Size = 'small' | 'large';

interface props {
	name: string;
	options: Array<Option>;
	required?: boolean;
	size?: Size;
	width?: string;
	onChange?: () => void; // Consideramos que ha clicado en un Cta
	onClick?: () => void; // Consideramos que ha clicado en cualquier Cta
	enableOnClick?: boolean;
}

export const CtasRadio = (props: props) => {
	const { name, options, required, size, width, onChange, onClick, enableOnClick } = props;
	const [value, setValue] = useState('');
	const [showError, setShowError] = useState(false);

	useFormField({
		name,
		value,
		required,
	});

	useEffect(() => {
		const unsubscribe = formService.subscribeToField(name, {
			onChange: (newValue) => {
				setValue(newValue ?? '');
				// Si se limpia el campo y ocultamos el error
				if (!newValue || newValue === '') {
					setShowError(false);
				}
			},
			onError: (hasError) => {
				setShowError(hasError);
			},
		});

		return unsubscribe;
	}, [name]);

	const handleChange = (value: string) => {
		formService.setFieldValue(name, value);
		// Al seleccionarlo limpiamos el posible error
		formService.setFieldError(name, false);
		onChange?.();
	};

	const getEmphasis = (option: Option) => {
		if (option.emphasis) {
			if (value && value != option.value) {
				// Mostramos emphasis secondary aunque el option tenga emphasis definida siempre que exista un value seleccionado y no sea la option
				return 'secondary';
			}
			return option.emphasis;
		} else if (value == option.value) {
			return 'primary';
		} else {
			return 'secondary';
		}
	};

	const getText = (option: Option) => {
		if (option.selectedText && value === option.value) {
			return option.selectedText;
		} else {
			return option.text;
		}
	};

	return (
		<div
			className="radio"
			data-on-click={enableOnClick ? true : undefined}
			onClick={() => {
				onClick?.();
			}}
		>
			<Container gutter={ContainerGutter.static300}>
				{options.map((option, index) => (
					<div
						key={index}
						style={{
							width: width || 'auto',
						}}
						className={`${'cta'} ${getEmphasis(option)} ${showError ? 'error' : ''}`}
					>
						<CTA
							onClick={(e) => {
								e.preventDefault();
								handleChange(option.value);
							}}
							emphasis={getEmphasis(option)}
							tag="button"
							size={size || 'small'}
							stretchContent={width ? true : undefined}
						>
							{getText(option)}
						</CTA>
					</div>
				))}
			</Container>
		</div>
	);
};
